export const LEARNING_TYPE_CLASSROOM = "Classroom";
export const LEARNING_TYPE_ONLINE = "Online";

export const DEFAULT_IMAGE = "./Content/img/program.png";

export const LIST_VIEW = "list";
export const CARD_VIEW = "card";

export const SORT_ORDER_TITLE_ASC = "title";
export const SORT_ORDER_TITLE_DESC = "title_desc";
export const SORT_ORDER_RATING_DESC = "rating";
export const SORT_ORDER_DATE_DESC = "date";
export const SORT_ORDER_NEWS_DESC = "news";
export const SORT_ORDER_TYPE_ASC = "type";

export const SORT_ORDER_TITLE_ASC_INT = 0;
export const SORT_ORDER_TITLE_DESC_INT = 5;
export const SORT_ORDER_RATING_DESC_INT = 2;
export const SORT_ORDER_DATE_DESC_INT = 1;
export const SORT_ORDER_NEWS_DESC_INT = 3;
export const SORT_ORDER_TYPE_ASC_INT = 4;

// Lookup table for sort order to sort type mapping
export const SORT_ORDER_TO_TYPE = {
  [SORT_ORDER_TITLE_ASC_INT]: "title",
  [SORT_ORDER_TITLE_DESC_INT]: "title_desc",
  [SORT_ORDER_DATE_DESC_INT]: "date",
  [SORT_ORDER_RATING_DESC_INT]: "rating",
  [SORT_ORDER_NEWS_DESC_INT]: "news",
  [SORT_ORDER_TYPE_ASC_INT]: "type",
};

export const DEFAULT_FILTER_OBJECT = {
  category1: 0,
  category2: 0,
  category3: 0,
  category4: 0,
  category5: 0,
};

export const FILTER_GROUP_THRESHOLD = 3;

export const SORT_OPTIONS = [
  {
    value: SORT_ORDER_TITLE_ASC_INT,
    label: "titlesort",
    sortType: SORT_ORDER_TITLE_ASC,
  },
  {
    value: SORT_ORDER_TITLE_DESC_INT,
    label: "titlesort_desc",
    sortType: SORT_ORDER_TITLE_DESC,
  },
  {
    value: SORT_ORDER_DATE_DESC_INT,
    label: "datesort",
    sortType: SORT_ORDER_DATE_DESC,
  },
  {
    value: SORT_ORDER_RATING_DESC_INT,
    label: "ratingsort",
    sortType: SORT_ORDER_RATING_DESC,
  },
  // Mute this for now
  // {
  //   value: SORT_ORDER_TYPE_ASC_INT,
  //   label: "typeofcourse",
  //   sortType: SORT_ORDER_TYPE_ASC,
  // },
];

export const STORAGE_KEY_SORT_ORDER = "LearningCatalogue_sortOrder";
export const STORAGE_KEY_FILTER_STATUS = "LearningCatalogue_filterStatus";
export const STORAGE_KEY_FAVORITES = "learningCatalogue_favorites";
export const STORAGE_KEY_CATALOGUE_VIEW = "LearningCatalogue_view";
export const CATALOGUE_PAGE_SIZE = 12;

// Query string keys used for URL deep linking
export const QUERY_KEYS = {
  q: "q",
  c1: "c1",
  c2: "c2",
  c3: "c3",
  c4: "c4",
  c5: "c5",
  from: "from",
  to: "to",
  region: "region",
  city: "city",
  sort: "sort",
  view: "view",
  page: "page",
};

export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes cache
